import { Winner } from '@flipster/apis/v1/exchange/types';
import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { useRouter } from '@flipster/i18n/routing';
import Formatted from '@flipster/react/design-utils/formatted';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { EarnEvent } from '@flipster/utils/segment/events/earn';

import { getSymbolPathname } from '@web/app/[locale]/(web)/trade/_misc/pathname';

import OrderSide from './OrderSide';

interface Props extends Winner {
  isSpot: boolean;
}

const MarqueeItem = ({ symbol, nickname, pnl, side, isSpot }: Props) => {
  const router = useRouter();

  return (
    <button
      type='button'
      className={flex({
        alignItems: 'center',
        py: 6,
        px: 10,
        gap: 4,
        '&:hover': {
          backgroundColor: 'background.default.level-1',
        },
      })}
      onClick={() => {
        router.push(getSymbolPathname(symbol, isSpot));
        segment.track(EarnEvent.PnlBannerClick, {
          symbol,
          side: side === 'Long' ? 'buy' : 'sell',
          realized_pnl: Number(pnl),
          page_type: 'trade_page',
        });
      }}
    >
      <SymbolDisplay
        symbol={symbol}
        icon={<SymbolDisplay.Icon size={16} space={4} />}
        mainLabel={
          <SymbolDisplay.Label
            value='shortName'
            css={{ textStyle: 'Text/S/Regular', color: 'content.default.level-5' }}
          />
        }
      />
      <OrderSide symbol={symbol} orderSide={side} />
      <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-5', pl: 4, pr: 2 })}>
        {nickname}
      </span>
      <Formatted.Number
        value={pnl}
        withPlus
        precision={2}
        toFixed
        css={{ textStyle: 'Text/S/Regular!', color: 'content.default.level-5' }}
      />
      <ChevronRightIcon size={20} color={token('colors.content.default.level-2')} />
    </button>
  );
};

export default MarqueeItem;
